<template>
  <div class="container">
    <div class="columns">
      <div class="column card is-three-fifths is-offset-one-fifth">
        <div class="section">
          <div class="content">
            <callout
              class="is-info"
              message="The Lead and Healthy Homes Database has been upgraded to use login.phila.gov for sign in. Your existing username and password will continue to allow you to access the site."
            />
          </div>
          <div class="content">
            <h2
              class="has-text-centered"
              v-html="$wording.login.title"
            />
            <p v-html="$wording.login.text_1" />
            <p v-text="$wording.login.text_2" />
            <p>
              <ul>
                <li>Upload lead disclosures and certifications.</li>
                <li>Complete the lead disclosure form.</li>
                <li>
                  <help-icon modal="file-for-an-exemption">
                    File for an exemption.
                  </help-icon>
                </li>
                <li>Manage and view disclosures, certifications, and exemptions.</li>
              </ul>
            </p>
            <div class="message is-info">
              <div class="message-body">
                <a
                  href="https://www.youtube.com/playlist?list=PLxVY78w5QKabfA1H5lkoeM-GBWtwiGDdr"
                  target="_blank"
                >HOW TO UPLOAD YOUR DOCUMENTS</a>
              </div>
            </div>
            <p v-html="$wording.login.visit_link" />
            <p>
              <a @click.prevent="$modal.show('coming-from-eclipse');">
                <help-icon modal="coming-from-eclipse">Coming from eCLIPSE? </help-icon> 
              </a>
            </p>
          </div>
          <div class="columns is-centered">
            <div class="column is-5 has-text-centered">
              <p
                v-show="actiongOcurring"
                class="has-text-weight-bold"
              >
                Please wait...
              </p>
              <div v-show="!actiongOcurring">
                <button
                  class="button is-primary is-fullwidth m-b-md"
                  :disabled="actiongOcurring"
                  @click="$store.dispatch('phillyAccount/msalSignIn')"
                >
                  Sign in
                </button>
                <button
                  :disabled="actiongOcurring"
                  class="button is-secondary is-fullwidth m-b-md"
                  @click="$store.dispatch('phillyAccount/msalSignIn', { extraQueryParameters: {domain_hint: 'signup'} })"
                >
                  CREATE AN ACCOUNT
                </button>
                
                <a
                  v-show="!actiongOcurring"
                  herf="#"
                  @click.prevent="$store.dispatch('phillyAccount/msalForgotPassword');"
                >
                  Forgot password?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <more-info
      id="coming-from-eclipse"
      title="Coming from eCLIPSE?"
    >
      <p>
        When you renew or apply for a <a
          href="https://www.phila.gov/services/permits-violations-licenses/get-a-license/business-licenses-permits-and-approvals/real-estate/get-a-rental-license/"
          target="_blank"
        >Rental License <i class="fas fa-external-link" /></a> or <a
          href="https://www.phila.gov/services/permits-violations-licenses/get-a-license/business-licenses-permits-and-approvals/day-care-centers/get-a-child-care-facility-license/"
          target="_blank"
        >Child Care Facility License <i class="fas fa-external-link" /></a>, you must complete the lead certification form on this site. To start the process, you'll need to log into the website and search for your property. If you don't have an account, you'll need to create one.
      </p>
      
      <p>Landlords must complete this process to: </p>
      <ol>
        <li>Execute or renew a lease. </li>
        <li>Get or renew a Rental License.</li>
      </ol>
      <p>Family child day care facilities need to complete this process to get or renew a Child Care Facility License.</p>
      <p>You can either certify that your property is lead-free or lead-safe, or you can apply for an exemption.</p>
    </more-info>
    <more-info
      id="file-for-an-exemption"
      title="File for an exemption"
    >
      <h3 class="is-size-5">
        Exemptions for newer properties
      </h3>
      <p>Properties built during or after 1978 can request an exemption through this site. If City records show that your property may have been built before 1978, this will open a case. You can review open cases on this site.</p>
      <h3 class="is-size-5">
        Exemptions for certain property types
      </h3>
      <p>If you believe your property is exempt because it's "Targeted Housing," such as a dormitory, contact the Lead and Healthy Homes Program at <a href="tel:+12156852788">(215) 685-2788</a>. LHHP staff will verify your information and make sure your property is exempt. If it is, they’ll enter your exemption into this system.</p>
    </more-info>
  </div>
</template>
<script>
import MoreInfo from "@/components/modals/MoreInfo";
import HelpIcon from "@/components/common/HelpIcon";

export default {
  name: "LoginPage",
  components: {
    MoreInfo,
    HelpIcon,
  },
  data() {
    return {
      email: "",
      password: "",
      logingIn: false,
    };
  },
  computed: {
    actiongOcurring() {
      return (
        this.$store.state.phillyAccount.signingIn ||
        this.$store.state.phillyAccount.redirectingForgotPassword
      );
    },
  },
  watch: {
    "$route.hash": {
      handler: function (newHash) {
        this.updateSigningIn(newHash);
      },
      deep: true,
    },
  },
  beforeMount() {
    this.updateSigningIn(this.$route.hash);
  },
  created() {
    this.$store.dispatch("phillyAccount/handleRedirect");
  },
  methods: {
    updateSigningIn(hash) {
      if (String(hash).indexOf("state=") !== -1) {
        this.$store.commit("phillyAccount/setSigningIn", true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.vertical-align-top-all {
  * {
    vertical-align: top;
  }
}
</style>
